var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-tasks text-center"},[_c('v-icon',{attrs:{"size":"100","color":"primary"}},[_vm._v(" mdi-check ")]),_c('div',{staticClass:"div parand primary--text"},[_vm._v("یادداشتی نیست")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }